module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Adjust-3239207f8c9314c635bdaf9cce2f4771e8efe66f6be93553f84bc1e53cb11c54.svg";